const toSlug = (value) =>
  String(value || '')
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

// The name is only there to make the link readable; the payment page resolves the practice by the
// trailing id, so renaming the practice never breaks a link that was already shared.
export const buildPaymentLinkUrl = (practice) => {
  if (!practice?.id) return '';
  const slug = toSlug(practice.dba_name || practice.name);
  return `${window.location.origin}/pay/${slug ? `${slug}-` : ''}${practice.id}`;
};

export const parsePaymentLinkPracticeId = (paymentLinkKey) =>
  String(paymentLinkKey || '').match(/(?:^|-)(\d+)$/)?.[1] || null;
